import { mask } from '../lib/privacy';
const COLOR = {
  card: "var(--pr-card)", ink: "var(--pr-ink)", ink2: "var(--pr-ink2)",
  muted: "var(--pr-muted)", line: "var(--pr-line)", green: "var(--pr-green)", teal: "var(--pr-teal)",
};

const fmt = (n) => mask(`$${Number(n).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`);
const pct = (r) => `${(Number(r) * 100).toFixed(1).replace(/\.0$/, "")}%`;

const Row = ({ label, value, sub, bold, color, testid }) => (
  <div className="flex items-baseline justify-between py-1" data-testid={testid}>
    <span className="text-xs" style={{ color: bold ? COLOR.ink : COLOR.ink2, fontWeight: bold ? 700 : 400 }}>
      {label}{sub && <span className="ml-1 text-[10px]" style={{ color: COLOR.muted }}>{sub}</span>}
    </span>
    <span className="text-sm" style={{ color: color || COLOR.ink, fontWeight: bold ? 700 : 600 }}>{value}</span>
  </div>
);

export const AllocationSummaryCard = ({ alloc }) => {
  if (!alloc || !(alloc.gross > 0 || alloc.debt || alloc.savings || alloc.pto)) return null;
  const t = alloc.tax || {};
  return (
    <div className="rounded-2xl p-5 lg:p-6 pr-card" data-testid="caddy-alloc-summary">
      <p className="text-xs font-bold uppercase tracking-widest mb-2" style={{ color: COLOR.muted }}>
        Money lanes this relay
      </p>
      <Row label="Gross earned so far" value={fmt(alloc.gross)} bold testid="alloc-gross" />
      <div className="my-1.5 border-t" style={{ borderColor: COLOR.line }} />
      {t.se && <Row label="Self-employment tax" sub={pct(t.se.rate)} value={fmt(t.se.amount)} testid="alloc-tax-se" />}
      {t.federal && <Row label="Federal income tax" sub={pct(t.federal.rate)} value={fmt(t.federal.amount)} testid="alloc-tax-federal" />}
      <Row label="Tax set-aside so far" value={fmt(t.total || 0)} bold testid="alloc-tax-total" />
      {alloc.payout_cost && alloc.payout_cost.rate > 0 && (
        <>
          <div className="my-1.5 border-t" style={{ borderColor: COLOR.line }} />
          <Row label="Estimated payout cost" sub={pct(alloc.payout_cost.rate)} value={fmt(alloc.payout_cost.amount)} testid="alloc-payout-cost" />
        </>
      )}
      {(alloc.debt || alloc.savings || alloc.pto) && <div className="my-1.5 border-t" style={{ borderColor: COLOR.line }} />}
      {alloc.debt != null && <Row label="Debt payment" sub="planned" value={fmt(alloc.debt)} testid="alloc-debt" />}
      {alloc.savings != null && <Row label="Savings" sub="planned" value={fmt(alloc.savings)} testid="alloc-savings" />}
      {alloc.pto != null && <Row label="PTO set-aside" sub="planned" value={fmt(alloc.pto)} color={COLOR.teal} testid="alloc-pto" />}
      <div className="my-1.5 border-t" style={{ borderColor: COLOR.line }} />
      <Row label="Take-home so far" value={fmt(alloc.take_home)} bold color={COLOR.green} testid="alloc-take-home" />
      <p className="text-[10px] mt-2 leading-relaxed" style={{ color: COLOR.muted }}>
        Tax lanes update live as you log, the fixed lanes come from your LEGEND. Money moves on payout day. Estimates, not tax advice.
        {alloc.payout_cost && alloc.payout_cost.rate > 0 && " Payout cost is an estimate figured on gross earned, so your actual transfer fee may differ."}
      </p>
    </div>
  );
};
